// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__MDr8W","FooterInner":"Footer_FooterInner__XYt6c"};